module.exports = __webpack_public_path__ + "static/media/our_mission.7df5334e.png";